import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import {
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Entry2xmjmyutzoq3p as Entry,
} from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysClass;
function HashMapKeys() {
  if (HashMapKeysClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor(backing) {
        return new.target.new_kotlin_collections_HashMapKeys_s1wvpe_k$(backing);
      }
      static new_kotlin_collections_HashMapKeys_s1wvpe_k$(backing) {
        var $this = this.new_kotlin_collections_AbstractMutableSet_hvoaax_k$();
        $this.backing_1 = backing;
        return $this;
      }
      get_size_woubt6_k$() {
        return this.backing_1.get_size_woubt6_k$();
      }
      isEmpty_y1axqb_k$() {
        return this.backing_1.get_size_woubt6_k$() === 0;
      }
      contains_aljjnj_k$(element) {
        return this.backing_1.contains_vbgn2f_k$(element);
      }
      clear_j9egeb_k$() {
        return this.backing_1.clear_j9egeb_k$();
      }
      add_utx5q5_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      addAll_h3ej1q_k$(elements) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      iterator_jk1svi_k$() {
        return this.backing_1.keysIterator_mjslfm_k$();
      }
      checkIsMutable_jn1ih0_k$() {
        return this.backing_1.checkIsMutable_h5js84_k$();
      }
    }
    initMetadataForClass($, 'HashMapKeys', VOID, VOID, [KtMutableSet()]);
    HashMapKeysClass = $;
  }
  return HashMapKeysClass;
}
var HashMapValuesClass;
function HashMapValues() {
  if (HashMapValuesClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor(backing) {
        return new.target.new_kotlin_collections_HashMapValues_4lttdc_k$(backing);
      }
      static new_kotlin_collections_HashMapValues_4lttdc_k$(backing) {
        var $this = this.new_kotlin_collections_AbstractMutableCollection_1gqjpn_k$();
        $this.backing_1 = backing;
        return $this;
      }
      get_size_woubt6_k$() {
        return this.backing_1.get_size_woubt6_k$();
      }
      isEmpty_y1axqb_k$() {
        return this.backing_1.get_size_woubt6_k$() === 0;
      }
      contains_m22g8e_k$(element) {
        return this.backing_1.containsValue_yf2ykl_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_m22g8e_k$(element);
      }
      add_sqnzo4_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      add_utx5q5_k$(element) {
        return this.add_sqnzo4_k$(element);
      }
      addAll_h3ejgd_k$(elements) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      addAll_h3ej1q_k$(elements) {
        return this.addAll_h3ejgd_k$(elements);
      }
      iterator_jk1svi_k$() {
        return this.backing_1.valuesIterator_3ptos0_k$();
      }
      checkIsMutable_jn1ih0_k$() {
        return this.backing_1.checkIsMutable_h5js84_k$();
      }
    }
    initMetadataForClass($, 'HashMapValues', VOID, VOID, [Collection(), MutableIterable()]);
    HashMapValuesClass = $;
  }
  return HashMapValuesClass;
}
var HashMapEntrySetClass;
function HashMapEntrySet() {
  if (HashMapEntrySetClass === VOID) {
    class $ extends HashMapEntrySetBase() {
      constructor(backing) {
        return new.target.new_kotlin_collections_HashMapEntrySet_7nlww9_k$(backing);
      }
      static new_kotlin_collections_HashMapEntrySet_7nlww9_k$(backing) {
        return this.new_kotlin_collections_HashMapEntrySetBase_d1wqzd_k$(backing);
      }
      iterator_jk1svi_k$() {
        return this.backing_1.entriesIterator_or017i_k$();
      }
    }
    initMetadataForClass($, 'HashMapEntrySet');
    HashMapEntrySetClass = $;
  }
  return HashMapEntrySetClass;
}
var HashMapEntrySetBaseClass;
function HashMapEntrySetBase() {
  if (HashMapEntrySetBaseClass === VOID) {
    class $ extends AbstractMutableSet() {
      static new_kotlin_collections_HashMapEntrySetBase_d1wqzd_k$(backing) {
        var $this = this.new_kotlin_collections_AbstractMutableSet_hvoaax_k$();
        $this.backing_1 = backing;
        return $this;
      }
      get_size_woubt6_k$() {
        return this.backing_1.get_size_woubt6_k$();
      }
      isEmpty_y1axqb_k$() {
        return this.backing_1.get_size_woubt6_k$() === 0;
      }
      contains_pftbw2_k$(element) {
        return this.backing_1.containsEntry_jg6xfi_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!(!(element == null) ? isInterface(element, Entry()) : false))
          return false;
        return this.contains_pftbw2_k$((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      clear_j9egeb_k$() {
        return this.backing_1.clear_j9egeb_k$();
      }
      add_k8z7xs_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      add_utx5q5_k$(element) {
        return this.add_k8z7xs_k$((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      addAll_h3ej1q_k$(elements) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_cv3bvm_k$();
      }
      containsAll_bwkf3g_k$(elements) {
        return this.backing_1.containsAllEntries_m9iqdx_k$(elements);
      }
      checkIsMutable_jn1ih0_k$() {
        return this.backing_1.checkIsMutable_h5js84_k$();
      }
    }
    initMetadataForClass($, 'HashMapEntrySetBase', VOID, VOID, [KtMutableSet()]);
    HashMapEntrySetBaseClass = $;
  }
  return HashMapEntrySetBaseClass;
}
//region block: exports
export {
  HashMapEntrySet as HashMapEntrySet29p2ksc4wcy5i,
  HashMapKeys as HashMapKeys28ggmxpft3hz9,
  HashMapValues as HashMapValues3umcxpfyfunqf,
};
//endregion

//# sourceMappingURL=HashMapEntry.mjs.map
